"use client";

import { GlobalContext } from "@/context";
import Image from "next/image";
import Link from "next/link";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import PopUpPasserPanier from "../PopUpPasserPanier";
const APropsSlides = ({ from, to, imgList }) => {
  // Add to panier functionallity
  const { connected, setPanierData } = useContext(GlobalContext);
  const [showPopUpPasserPanier, setShowPopUpPasserPanier] = useState(false);

  const addProductToPanier = (data) => {
    const panierData = JSON.parse(localStorage.getItem("panier")) || [];
    const panierArray = panierData.find((el) => el._id == data._id)
      ? panierData.map((el) =>
          el._id == data._id ? { ...el, qt: el.qt + 1 } : el
        )
      : [...panierData, { ...data, qt: 1 }];
    localStorage.setItem("panier", JSON.stringify(panierArray));
    setPanierData(panierArray);
    setShowPopUpPasserPanier(true);
  };

  const addProductToFavoriteList = async (productId) => {
    if (connected) {
      const data = await axios
        .post(
          "/auth/addfavoriteproduct",
          {
            productId: productId,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => res.data)
        .then((res) => toast.success("Produit ajouté aux favoris !"))
        .catch((err) => {
          toast.error(err.response.data.message);
        });
    } else {
      toast.error("Veuillez vous connecter pour ajouter aux favoris");
    }
  };

  const [index, setIndex] = useState([...Array(to + 1).keys()].map((i) => i));
  const minus = () => {
    setIndex([
      ...index.map((el) => {
        return el == 0 ? to : el - 1;
      }),
    ]);
  };
  const plus = () => {
    setIndex([
      ...index.map((el) => {
        return el == to ? 0 : el + 1;
      }),
    ]);
  };

  return (
    <div className="flex items-center justify-between pb-8">
      <Image
        src={"/icons/portesClesFleshLeft.png"}
        height={36}
        width={57}
        className="lg:-ml-0 w-[20px] lg:w-[36px] h-[30px] lg:h-[57px] cursor-pointer"
        onClick={minus}
        alt="Flesh-Left-icon"
      />
      {/*First Product Card*/}
      <div className="hidden lg:flex flex-col justify-between bg-white rounded-3xl  bg-contain bg-no-repeat w-[271px] h-[388px] p-4">
        <div className="h-[20%]"></div>
        <Link
          href={`/product/${imgList[index[0]]?.categories[0]}/${
            imgList[index[0]]?._id
          }`}
          className="h-[60%]"
        >
          <img
            src={imgList[index[0]]?.image}
            width={300}
            height={264}
            className="w-full h-full"
            alt="Product-Photo"
          />
        </Link>
        <div className="h-[20%] flex justify-between items-end">
          <h2 className="text-[13px] lg:text-[20px] w-[70%]">
            {imgList[index[0]]?.name}
          </h2>
          <div className="flex gap-2">
            <Image
              src={"/icons/panier.png"}
              height={27}
              width={33}
              className="w-[26px] h-[22px] cursor-pointer"
              alt="panier-icon"
              onClick={() => addProductToPanier(imgList[index[0]])}
            />
            <Image
              src={"/icons/favorite.png"}
              height={21}
              width={23}
              className="w-[23px] h-[20px] cursor-pointer"
              alt="favorite-icon"
              onClick={() => addProductToFavoriteList(imgList[index[0]]._id)}
            />
          </div>
        </div>
      </div>
      {/*Second Product Card*/}
      <div className="lg:flex flex-col justify-between bg-white rounded-3xl bg-contain bg-no-repeat w-[271px] h-[388px] p-4">
        <div className="hidden md:block h-[20%]"></div>
        <Link
          href={`/product/${imgList[index[1]]?.categories[0]}/${
            imgList[index[1]]?._id
          }`}
          className="h-[60%]"
        >
          <img
            src={imgList[index[1]]?.image}
            width={300}
            height={264}
            className="w-full h-[80%] md:h-full"
            alt="Product-Photo"
          />
        </Link>
        <div className="h-[20%] flex justify-between items-end">
          <h2 className="text-[13px] lg:text-[20px] w-[70%]">
            {imgList[index[1]]?.name}
          </h2>
          <div className="flex gap-2">
            <Image
              src={"/icons/panier.png"}
              height={27}
              width={33}
              className="w-[26px] h-[22px] cursor-pointer"
              alt="panier-icon"
              onClick={() => addProductToPanier(imgList[index[1]])}
            />
            <Image
              src={"/icons/favorite.png"}
              height={21}
              width={23}
              className="w-[23px] h-[20px] cursor-pointer"
              alt="favorite-icon"
              onClick={() => addProductToFavoriteList(imgList[index[1]]._id)}
            />
          </div>
        </div>
      </div>
      {/*Third Product Card*/}
      <div className="hidden lg:flex flex-col justify-between bg-white rounded-3xl bg-contain bg-no-repeat w-[271px] h-[388px] p-4">
        <div className="h-[20%]"></div>
        <Link
          href={`/product/${imgList[index[2]]?.categories[0]}/${
            imgList[index[2]]?._id
          }`}
          className="h-[60%]"
        >
          <img
            src={imgList[index[2]]?.image}
            width={300}
            height={264}
            className="w-full h-full"
            alt="Product-Photo"
          />
        </Link>
        <div className="h-[20%] flex justify-between items-end">
          <h2 className="text-[13px] lg:text-[20px] w-[70%]">
            {imgList[index[2]]?.name}
          </h2>
          <div className="flex gap-2">
            <Image
              src={"/icons/panier.png"}
              height={27}
              width={33}
              className="w-[26px] h-[22px] cursor-pointer"
              alt="panier-icon"
              onClick={() => addProductToPanier(imgList[index[2]])}
            />
            <Image
              src={"/icons/favorite.png"}
              height={21}
              width={23}
              className="w-[23px] h-[20px] cursor-pointer"
              alt="favorite-icon"
              onClick={() => addProductToFavoriteList(imgList[index[2]]._id)}
            />
          </div>
        </div>
      </div>
      <Image
        src={"/icons/portesClesFleshRight.png"}
        height={36}
        width={57}
        className="lg:-mr-0 w-[20px] lg:w-[36px] h-[30px] lg:h-[57px] cursor-pointer"
        onClick={plus}
        alt="Flesh-Right-icon"
      />


      {showPopUpPasserPanier ? (
        <PopUpPasserPanier
          showPopUpPasserPanier={showPopUpPasserPanier}
          setShowPopUpPasserPanier={setShowPopUpPasserPanier}
        />
      ) : null}
    </div>
  );
};

export default APropsSlides;
